import InteractiveVisualizationParser from './InteractiveVisualizationParser';
import { TOOL_TYPE } from './ToolType';

// Instancias de parsers para cada tipo de visualización interactiva
export const threejsParser = new InteractiveVisualizationParser(
  'Threejs',
  'THREEJS_VISUALIZATION',
  '/visualizations/threejs/',
  TOOL_TYPE.THREEJS_VISUALIZATION
);

export const d3Parser = new InteractiveVisualizationParser('D3', 'D3_VISUALIZATION', '/visualizations/d3/', TOOL_TYPE.D3_VISUALIZATION);

export const geogebraParser = new InteractiveVisualizationParser(
  'Geogebra',
  'GEOGEBRA_VISUALIZATION',
  '/visualizations/geogebra/',
  TOOL_TYPE.GEOGEBRA_VISUALIZATION
);

// Array con todos los parsers para facilitar su uso
export const interactiveParsers = [threejsParser, d3Parser, geogebraParser];
